module.exports = __webpack_public_path__ + "static/media/rbi_black.f6fefbc5.svg";